export enum DocumentAntivirusScanStatus {
  // the file has not been scanned yet
  UNSCANNED = 'UNSCANNED',
  // the file has been found to be infected
  INFECTED = 'INFECTED',
  // the file has been scanned and no viruses were detected
  CLEAN = 'CLEAN',
}
